import React from "react"
import {
    Tabs,
    Tab,
    Paper
} from "@mui/material"
import { styled } from "@mui/material/styles"
import ThemeProviderWrapper from "./ThemeProviderWrapper"

const SFTab = styled(Tab)({
  fontSize: '14px',
  color: '#64b5f6',
  opacity: 0.7,
  '&.Mui-selected': {
    opacity: 1,
  },
  '&:hover': {
    opacity: 1,
  },
})

export default class ProfileNavTabs extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }


  render() {
    const {
      samplesCount,
      collectionsCount,
      downloadsCount,
      favoritesCount,
      sequencesCount,
      userSamplesPath,
      userCollectionsPath,
      userDownloadsPath,
      userFavoritesPath,
      userSequencesPath
    } = this.props

    const possibleTabsInOrder = ['samples', 'sequences', 'collections', 'downloads', 'favorites']
    const currentPosition = possibleTabsInOrder.indexOf(this.props.selectedPage)
    return (
      <ThemeProviderWrapper>
        <Paper elevation={2} sx={{ width: '100%', bgcolor: 'background.paper', margin: '0 10px'}}>

          <Tabs
            value={currentPosition}
            aria-label="user profile nav tabs"
            role="navigation"
            centered
            textColor="secondary"
            indicatorColor="secondary"
          >
            <SFTab component="a" label={`${samplesCount} Uploads`} href={userSamplesPath} />
            <SFTab component="a" label={`${sequencesCount} Sequences`} href={userSequencesPath} />
            <SFTab component="a" label={`${collectionsCount} Collections`} href={userCollectionsPath} />
            <SFTab component="a" label={`${downloadsCount} Downloads`} href={userDownloadsPath} />
            <SFTab component="a" label={`${favoritesCount} Favorites`} href={userFavoritesPath} />
          </Tabs>
        </Paper>
      </ThemeProviderWrapper>
    )
  }
}
